<template>
  <customModal :containerxl="true" @closeModal=closeModal>

    <template #title>
      {{ $t("navigations.view log") }}
    </template>

    <template #body>
       <div class="log-body-wrapper">
      <!-- Loader -->
      <div class="center-state" v-if="logLoader">
        <img src="../../assets/img/loading.gif" width="15" alt="Loading" />
        <p class="mt-2">{{ $t("navigations.please wait") }}</p>
      </div>

      <!-- No Log -->
      <div v-else-if="!logData" class="center-grid">
        <i class="fa fa-exclamation-circle fa-2x text-muted"></i>
        <p class="mt-2 text-muted">{{ $t("navigations.no log available") }}</p>
      </div>

      <!-- Log Content -->
      <div v-else>
        <div class="info-card-title mb-1">
               <i class="fa fa-info-circle mr-1"></i> {{ $t("navigations.program info") }}
        </div>
     
       <!-- Programme Info -->
<div class="info-card mb-3">
  <div v-if="activeTab=='execution'" class="align-items-center gap-4 mt-0" style="font-size:12px;">
    <!-- Programme full title -->
    <div class="d-flex justify-content-between align-items-center mb-2">
      <span>
        <i class="fa fa-television mr-1 text-primary"></i>
        <strong>{{ logData.FullTitle }}</strong>
      </span>
      <span :class="logData.status === 'Success' ? 'badge-success-custom' : 'badge-error-custom'">
        <i :class="logData.status === 'Success' ? 'fa fa-check-circle' : 'fa fa-times-circle'"></i>
        {{ logData.status }}
      </span>
    </div>
    <div class="d-flex gap-4">
      <span>
        <i class="fa fa-user-circle-o mr-1 text-primary"></i>{{ $t("navigations.run by") }}:
        <strong>{{ logData.RunByName}}</strong>
      </span>
      <span class="separator">|</span>
      <span>
        <i class="fa fa-code-fork mr-1"></i> {{ $t("navigations.version") }}:
        <strong>{{ logData.Version }}</strong>
      </span>
      <span class="separator">|</span>
      <span>
        <i class="fa fa-calendar mr-1"></i>{{$t("navigations.date")}}:
        <strong>{{formatDate(logData.CreatedAt)}}</strong>
      </span>
      <span class="separator">|</span>
      <span>
        <i class="fa fa-hourglass-half mr-1"></i>{{$t("navigations.duration")}}:
        <strong>{{ logData.Duration }}</strong>
      </span>
      <span class="separator">|</span>
      <span>
        <i class="fa fa-sitemap mr-1"></i>{{$t("navigations.program type")}}:
        <strong>{{ logData.ProgramType }}</strong>
      </span>
    </div>
  </div>

  <div v-else class="d-flex justify-content-between align-items-center h-100" style="font-size:12px; min-height: 42px;">
    <span>
      <i class="fa fa-television mr-1 text-primary"></i>
      <strong>{{ logData.FullTitle }}</strong>
    </span>
    <div class="d-flex align-items-center flex-wrap gap-2" style="font-size:12px;">
      <span class="stat-pill stat-success">
        <i class="fa fa-check-circle"></i> {{ historySuccessCount }} {{$t("navigations.success")}}
      </span>
      <span class="stat-pill stat-error">
        <i class="fa fa-times-circle"></i> {{ historyFailedCount }} {{ $t("navigations.failed") }}
      </span>
    </div>
  </div>
</div>

        <!-- Tabs -->
        <div class="log-tabs mb-2">
          <button
            class="log-tab"
            :class="{ 'log-tab-active': activeTab === 'execution' }"
            @click="activeTab = 'execution'"
          >
            <i class="fa fa-terminal mr-1"></i>{{$t("navigations.execution log")}}
          </button>
          <button
            class="log-tab"
            :class="{ 'log-tab-active': activeTab === 'history' }" 
            @click="activeTab = 'history'"
          >
            <i class="fa fa-history mr-1"></i>{{ $t("navigations.run history") }}
            <span class="history-count" v-if="historyTotalCount">{{ historyTotalCount }}</span>
          </button>
        </div>

        <!-- Execution Log Tab -->
        <div v-if="activeTab === 'execution'">
          <!-- Stats Bar -->
          <!-- <div class="d-flex align-items-center flex-wrap gap-2 mb-2" style="font-size:12px;">
            <span class="stat-pill stat-success"><i class="fa fa-check-circle"></i> {{ successCount }} success</span>
            <span class="stat-pill stat-warning"><i class="fa fa-exclamation-triangle"></i> {{ warningCount }} warning</span>
            <span class="stat-pill stat-error"><i class="fa fa-times-circle"></i> {{ errorCount }} error</span>
            <span class="stat-pill stat-info"><i class="fa fa-info-circle"></i> {{ infoCount }} info</span>
            <span class="stat-pill stat-neutral">{{ filteredLines.length }} total lines</span>
          </div> -->

          <!-- Filter Bar -->
          <div class="d-flex align-items-center flex-wrap gap-2 mb-2">
            <div class="log-search-wrapper">
              <i class="fa fa-search log-search-icon"></i>
              <input
                v-model="searchQuery"
                class="log-search-input"
                placeholder="Search logs..."
              />
            </div>
            <button class="filter-btn" :class="{ 'filter-btn-active': levelFilter === 'all' }" @click="levelFilter = 'all'">All</button>
            <button class="filter-btn filter-btn-success" :class="{ 'filter-btn-active': levelFilter === 'success' }" @click="levelFilter = 'success'">
              <i class="fa fa-check-circle"></i> {{$t("navigations.success")}}
            </button>
            <button class="filter-btn filter-btn-warning" :class="{ 'filter-btn-active': levelFilter === 'warning' }" @click="levelFilter = 'warning'">
              <i class="fa fa-exclamation-triangle"></i>{{$t("navigations.warning")}}
            </button>
            <button class="filter-btn filter-btn-error" :class="{ 'filter-btn-active': levelFilter === 'error' }" @click="levelFilter = 'error'">
              <i class="fa fa-times-circle"></i>{{$t("navigations.error")}}
            </button>
            <button class="filter-btn" @click="copyLog">
              <i class="fa fa-copy mr-1"></i> {{ copied ? 'Copied' : 'Copy' }}
            </button>
            <button class="filter-btn filter-btn-download" @click="downloadLog">
              <i class="fa fa-download mr-1"></i>{{$t("navigations.download")}}
            </button>
          </div>

          <!-- Log Lines -->
          <div class="log-terminal">
            <div
              v-for="(line, idx) in filteredLines"
              :key="idx"
              class="log-line"
              :class="getLineClass(line.level)"
            >
              <span class="log-line-num">{{ line.lineNum }}</span>
              <span class="log-line-time">{{ line.time }}</span>
              <span class="log-line-msg">{{ line.message }}</span>
            </div>
            <div v-if="filteredLines.length === 0" class="text-center py-3 text-muted" style="font-size:12px;">
              {{$t("navigations.no lines match the filter")}}
            </div>
          </div>
        </div>

  
       <!-- Run History Tab -->
          <div v-if="activeTab === 'history'">
  <div v-if="historyLoader" class="text-center py-4">
    <img src="../../assets/img/loading.gif" width="15" alt="Loading" />
    <p class="mt-2 mb-0">{{ $t("navigations.please wait the list is loading") }}</p>
  </div>
  <div v-else-if="logData.runHistory && logData.runHistory.length > 0">
    <div class="table-terminal">
      <table class="table table-sm table-bordered" style="font-size:12px;">
        <thead>
          <tr>
            <th>{{$t("navigations.date")}}</th>
            <th>{{$t("navigations.run by")}}</th>
            <th>{{$t("navigations.report type")}}</th>
            <th>{{$t("navigations.program type")}}</th>
            <th class="text-center">{{$t("navigations.status")}}</th>
            <th class="text-center">{{$t("navigations.duration")}}</th>
            <th class="text-center">{{$t("navigations.version")}}</th>
            <th class="text-center">{{$t("navigations.action")}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(h, i) in paginatedHistory" :key="i">
            <td>{{ formatDate(h.runAt) }}</td>
            <td>{{ h.RunByName }}</td>
            <td>{{ h.reportType }}</td>
            <td>{{ h.programType }}</td>
            <td class="text-center">
              <span :class="h.status === 'Success' ? 'badge-success-custom' : 'badge-error-custom'">
                {{ h.status }}
              </span>
            </td>
            <td class="text-center">{{ h.duration }}</td>
            <td class="text-center">{{ h.version }}</td>
            <td class="text-center">
              <i
                class="fa fa-eye editicon"
                @click.prevent="viewHistoryLog(h.id)"
                title="View Log"
              ></i>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination — same as Study Profile -->
    <div class="col-lg-12 d-flex justify-content-lg-end px-0 mt-1">
      <v-pagination
        v-model="historyPage"
        :pages="totalHistoryPages"
        :range-size="0"
        active-color="#f4f9ff"
        @update:modelValue="onHistoryPageChange"
      />
    </div>

  </div>
  <div v-else class="text-center py-3 text-muted" style="font-size:12px;">
    {{ $t("navigations.no run history available") }}
  </div>
        </div>

      </div>
      </div>
    </template>

  </customModal>
</template>

<script src="./ViewlogModal.js"></script>

<style scoped>
.info-card {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 10px 12px;
  background: #f8faff;
  min-height: 58px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.info-card-title {
  font-size: 12px;
  font-weight: 700;
  color: #145faf;
  text-transform: none;
  letter-spacing: 0.4px;
}
.separator { color: #bbb; }
.badge-success-custom {
  background: #d4f0dc;
  color: #1a7a3a;
  border: 1px solid #a3d9b1;
  border-radius: 12px;
  padding: 2px 8px;
  font-size: 10px;
  font-weight: 700;
  align-items: center;
  justify-content: center;
}
.badge-error-custom {
  background: #fde8e8;
  color: #c0392b;
  border: 1px solid #f5c6c6;
  border-radius: 12px;
  padding: 2px 10px;
  font-size: 10px;
  font-weight: 700;
}
.summary-card {
  flex: 1;
  min-width: 130px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 8px 12px;
  background: #fff;
}
.summary-label {
  font-size: 10px;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin-bottom: 4px;
}
.summary-value {
  font-size: 22px;
  font-weight: 700;
  color: #222;
  line-height: 1.2;
}
.summary-value-sm {
  font-size: 14px !important;
}
.summary-sub {
  font-size: 10px;
  color: #aaa;
  margin-top: 2px;
}
.log-tabs {
  display: flex;
  border-bottom: 2px solid #e0e0e0;
  gap: 0;
}
.log-tab {
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  padding: 6px 16px;
  font-size: 12px;
  font-weight: 600;
  color: #666;
  cursor: pointer;
}
.log-tab-active {
  border-bottom: 2px solid #145faf;
  color: #145faf;
}
.history-count {
  background: #145faf;
  color: #fff;
  border-radius: 10px;
  padding: 1px 6px;
  font-size: 10px;
  margin-left: 4px;
}
.stat-pill {
  border-radius: 10px;
  padding: 2px 8px;
  font-size: 11px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  line-height: 1.4;
  gap: 4px;
}
.stat-success { background: #eaf7ed; color: #1a7a3a; }
.stat-warning { background: #fff8e1; color: #b8860b; }
.stat-error   { background: #fdeaea; color: #c0392b; }
.stat-info    { background: #e8f0fe; color: #145faf; }
.stat-neutral { background: #f0f0f0; color: #555; }

.log-search-wrapper {
  position: relative;
  flex: 1;
  min-width: 180px;
}
.log-search-icon {
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
  color: #aaa;
  font-size: 12px;
}
.log-search-input {
  width: 100%;
  padding: 4px 8px 4px 26px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 12px;
  outline: none;
}
.filter-btn {
  border: 1px solid #ddd;
  background: #f8f8f8;
  border-radius: 4px;
  padding: 3px 10px;
  font-size: 11px;
  cursor: pointer;
  font-weight: 600;
  color: #555;
}
.filter-btn-active {  background: linear-gradient(45deg, #145faf, #04223b);
; color: #fff; border-color: #145faf; }
.filter-btn-success { color: #1a7a3a; }
.filter-btn-warning { color: #b8860b; }
.filter-btn-error   { color: #c0392b; }
.filter-btn-download { background: #145faf; color: #fff; border-color: #145faf; }

.log-terminal {
  background: #111;
  border-radius: 4px;
  padding: 8px 0;
  max-height: 248px;
  min-height: 248px;  
  overflow-y: auto;
  font-family: "Courier New", monospace;
  font-size: 12px;
}
.table-terminal{
  max-height: 248px;
  overflow-y: auto;
  font-size: 12px;
  min-height: 248px;  
}
.log-line {
  display: flex;
  align-items: flex-start;
  padding: 1px 10px;
  line-height: 1.7;
}
.log-line:hover { background: rgba(255,255,255,0.04); }
.log-line-num  { color: #555; min-width: 28px; user-select: none; }
.log-line-time { color: #888; min-width: 70px; margin-right: 8px; }
.log-line-msg  { flex: 1; }

.log-line-success .log-line-msg { color: #4caf50; }
.log-line-warning .log-line-msg { color: #ffc107; }
.log-line-error   .log-line-msg { color: #f44336; }
.log-line-info    .log-line-msg { color: #64b5f6; }
.log-line-default .log-line-msg { color: #d4d4d4; }

.fda-footer {
  font-size: 11px;
  color: #888;
  border-top: 1px solid #e0e0e0;
  padding-top: 6px;
}
.log-body-wrapper {
  min-height: 434px;        /* full modal body fixed */
  display: flex;
  flex-direction: column;
}

.log-content {
  flex: 1;              /* takes remaining space */
  overflow-y: auto;     /* scroll only here */
}

.loader-wrapper {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.center-state {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
}
.center-grid{
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
}
</style>
